import styled from "styled-components";
import Icon from "../../../../../base/icons/icon/index.js";
import { TitleStyled } from "../../../../../base/text/title/views/desktop/styled.js";
import CardSimpleDesktop from "../../../../cards/card-simple/views/desktop/index.js";
import Slider from "../../../../../structures/others/slider/index.js";
import { BoxShadow, BoxShadowWithHover } from "../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius, Margin, Padding } from "../../../../../../styles/common/mixins/logical.styled.js";
export const MasonryBox = styled.div.withConfig({
    displayName: "styled__MasonryBox",
    componentId: "sc-ce81f84b-0"
})`
	${Padding({
    top: '44px',
    x: '0',
    bottom: '48px'
})};

	&.bg_primary {
		background-color: ${({ theme  })=>theme.colors.primary.lighter};
		${TitleStyled} {
			color: ${({ theme  })=>theme.colors.white.base};
		}
	}
`;
export const MasonryWrapperCards = styled.div.withConfig({
    displayName: "styled__MasonryWrapperCards",
    componentId: "sc-ce81f84b-1"
})`
	${FlexMixin({
    direction: 'column',
    justify: 'space-between'
})}
`;
export const MasonryCard = styled.a.withConfig({
    displayName: "styled__MasonryCard",
    componentId: "sc-ce81f84b-2"
})`
	${BoxShadowWithHover}
	${Margin({
    top: '1px',
    x: '1px',
    bottom: '16px'
})}

	position: relative;
	overflow: hidden;
	width: 100%;
	overflow: hidden;

	&:not(:last-child) {
		${({ $isRegular  })=>$isRegular ? `margin-bottom: 2px;` : `margin-bottom: 16px;`}
	}

	img {
		width: 100%;
	}
`;
export const MasonryCardBody = styled.div.withConfig({
    displayName: "styled__MasonryCardBody",
    componentId: "sc-ce81f84b-3"
})`
	&.primary {
		background-color: ${({ theme  })=>theme.colors.white.lowest};
		bottom: 0;
		color: ${({ theme  })=>theme.colors.grays.darker};
		${Padding({
    all: '12px'
})};
		position: absolute;
		width: 100%;
	}

	&.secondary {
		background-color: ${({ theme  })=>theme.colors.white.lowest};
		${BorderRadius({
    all: '4px'
})};
		bottom: 12px;
		color: ${({ theme  })=>theme.colors.grays.darker};
		left: 12px;
		${Padding({
    all: '12px'
})};
		position: absolute;
		width: auto;
	}
`;
export const MasonryCardTitle = styled.p.withConfig({
    displayName: "styled__MasonryCardTitle",
    componentId: "sc-ce81f84b-4"
})`
	${FontMixin({
    size: 'base',
    height: 'base',
    weight: 'bold'
})}
`;
export const MasonryCardDescription = styled.p.withConfig({
    displayName: "styled__MasonryCardDescription",
    componentId: "sc-ce81f84b-5"
})`
	${FontMixin({
    size: 'medium',
    height: 'medium',
    weight: 'light'
})}
`;
export const MasonryRegularContainer = styled.div.withConfig({
    displayName: "styled__MasonryRegularContainer",
    componentId: "sc-ce81f84b-6"
})`
	position: absolute;
	left: 24px;
	bottom: 20px;
	${FlexMixin({
    direction: 'row'
})};
`;
export const WrapperImage = styled.div.withConfig({
    displayName: "styled__WrapperImage",
    componentId: "sc-ce81f84b-7"
})`
	position: relative;
`;
export const MasonryRegularTitleWrapper = styled.div.withConfig({
    displayName: "styled__MasonryRegularTitleWrapper",
    componentId: "sc-ce81f84b-8"
})`
	background-color: ${({ theme  })=>theme.colors.white.lowest};
	${BorderRadius({
    topLeft: '4px',
    bottomLeft: '4px'
})};
	color: ${({ theme  })=>theme.colors.grays.darker};
	${Padding({
    all: '10px'
})};
	width: auto;
	${FlexMixin({
    align: 'center'
})};

	${({ theme  })=>theme.media.down('sm')} {
		${Padding({
    y: '7px',
    x: '10px'
})};
		color: ${({ theme  })=>theme.colors.grays.darker};
		position: absolute;
		left: 10px;
		bottom: 8px;
	}
`;
export const MasonryCardRegularPrice = styled.div.withConfig({
    displayName: "styled__MasonryCardRegularPrice",
    componentId: "sc-ce81f84b-9"
})`
	background-color: ${({ theme  })=>theme.colors.secondary.base};
	color: ${({ theme  })=>theme.colors.white.base};
	${BorderRadius({
    topRight: '4px',
    bottomRight: '4px'
})};
	${FlexMixin({
    direction: 'column'
})};
	${Padding({
    x: '12px',
    y: '4px'
})};
	min-width: 80px;
	max-width: 80px;

	p {
		text-align: left;
		${FontMixin({
    size: 'small',
    height: 'base',
    weight: 'regular'
})};

		:last-child {
			${FontMixin({
    size: 'base',
    weight: 'medium'
})};
			line-height: 21px;
		}
	}

	${({ theme  })=>theme.media.down('sm')} {
		position: absolute;
		top: 5px;
		right: 10px;
		${Padding({
    x: '10px',
    y: '5px'
})};
		${BorderRadius({
    all: '2px'
})};
	}
`;
export const PriceMobileContainer = styled.div.withConfig({
    displayName: "styled__PriceMobileContainer",
    componentId: "sc-ce81f84b-10"
})`
	${FlexMixin({
    direction: 'row',
    align: 'center',
    justify: 'center'
})};
	span {
		${FontMixin({
    size: 'large',
    height: 'base',
    weight: 'medium'
})};
	}

	p {
		${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'medium'
})};
	}
`;
export const MasonrySlider = styled(Slider).withConfig({
    displayName: "styled__MasonrySlider",
    componentId: "sc-ce81f84b-11"
})`
	.splide__arrows .splide__arrow {
		${FontMixin({
    size: 'larger',
    height: 'base'
})}

		&:hover {
			color: ${({ theme  })=>theme.colors.primary.base};
		}
	}

	.splide__arrows .splide__arrow[disabled] {
		opacity: 0;
		height: 0;
		transition: opacity 0.5s;

		& > i {
			font-size: 0;
		}
	}

	.splide__arrows .splide__arrow--prev {
		margin-left: -18px;
	}

	.splide__arrows .splide__arrow--next {
		margin-right: -18px;
	}

	.splide__arrows .splide__arrow {
		width: 36px;
		height: 36px;
		background-color: ${({ theme  })=>theme.colors.white.base};
		margin-left: -18px;
		${FlexMixin({
    justify: 'center',
    align: 'center'
})};
		${BorderRadius({
    all: '50%'
})}
		${BoxShadow}
		opacity: 1;

		transition: opacity 0.5s ease-in-out;

		& > i {
			font-size: 12px;
		}
	}
`;
export const MasonryViewMoreBack = styled.div.withConfig({
    displayName: "styled__MasonryViewMoreBack",
    componentId: "sc-ce81f84b-12"
})`
	padding-top: ${({ $paddingTop  })=>$paddingTop};
`;
export const MasonryViewMore = styled.span.withConfig({
    displayName: "styled__MasonryViewMore",
    componentId: "sc-ce81f84b-13"
})`
	${FlexMixin({
    direction: 'column',
    align: 'center',
    justify: 'center'
})}
	top:0;
	position: absolute;
	height: 100%;
	width: 100%;
	background: ${({ theme  })=>theme.colors.white.base};

	${Icon} {
		border: 1px solid ${({ theme  })=>theme.colors.primary.base};
		border-radius: ${({ theme  })=>theme.border.radius.circle};
		${Margin({
    bottom: '12px'
})};
		${Padding({
    all: '20px'
})};
		${FontMixin({
    size: 'larger',
    weight: 'bold'
})}
	}
`;
export const CardSimpleDsk = styled(CardSimpleDesktop).withConfig({
    displayName: "styled__CardSimpleDsk",
    componentId: "sc-ce81f84b-14"
})`
	${Margin({
    top: '1px',
    x: '1px',
    bottom: '16px'
})}
`;

//# sourceMappingURL=styled.js.map